import { render, staticRenderFns } from "./DashboardsManagement.vue?vue&type=template&id=12415d37&scoped=true&"
import script from "./DashboardsManagement.vue?vue&type=script&lang=js&"
export * from "./DashboardsManagement.vue?vue&type=script&lang=js&"
import style0 from "./DashboardsManagement.vue?vue&type=style&index=0&id=12415d37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12415d37",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/acarmichael/Desktop/DEV/BOSS40-FrontEnd/boss-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VCard,VDataTable,VFlex,VLayout})
